import { render } from "./CareOverviewModal.vue?vue&type=template&id=09b51627"
import script from "./CareOverviewModal.vue?vue&type=script&lang=js"
export * from "./CareOverviewModal.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__